import React from 'react'
import { permissions } from 'settings/permissions'
import { checkPermList } from 'helpers'
import Stores from 'Stores'
import SidebarIcon from './SidebarIcons/SidebarIcons'

export const checkBigMenu = (items) => {
  let count = 0
  let parent, key
  for (let a in items) {
    for (let b in items[a]) {
      if (b === 'items') {
        for (let c in items[a][b]) {
          for (let d in items[a][b][c]) {
            if (d === 'parent_key') parent = items[a][b][c][d]
            if (d === 'key') key = items[a][b][c][d]
            if (d === 'permissions') {
              if (Stores.Rules.checkRule2(parent, key, items[a][b][c][d]))
                count += 1
            }
          }
        }
      }
    }
  }
  return count > 0
}

export const checkCats = (array) => array.some(checkPermList)

export const menuSettings = [
  {
    id: 1,
    title: 'online_booking',
    isGroup: true,
    cats: [
      {
        title: 'online_booking',
        roles: ['admin', 'teacher', 'students', 'clients'],
        icon: <SidebarIcon variant='booking' />,
        items: [
          {
            title: 'online_booking_settings',
            ...permissions.view_company_settings,
          },
          {
            title: 'schedule_settings',
            ...permissions.view_schedule_settings_v2,
          },
          {
            title: 'my_schedule',
            ...permissions.view_teacher_schedule_v2,
          },
          {
            title: 'customer_booking',
            ...permissions.record_online_customer_v2,
          },
          {
            title: 'passed_tests',
            ...permissions.view_placement_test_list_result,
          },
          {
            title: 'customer_booking_schedule',
            ...permissions.view_booked_online_schedule_v2,
          },
          {
            title: 'future_bookings',
            ...permissions.view_online_slots_v2,
            link: 'online-schedule-v2/slots/future/',
          },
          {
            title: 'past_bookings',
            ...permissions.view_online_slots_v2,
            link: 'online-schedule-v2/slots/past/',
          },
          {
            title: 'customer_booking_history',
            ...permissions.view_clients_after_online_v2,
          },
          {
            title: 'employee_booking_history',
            ...permissions.view_teachers_history,
          },
          {
            title: 'employee_schedule_calendar',
            ...permissions.edit_advanced_teachers_history,
          },
        ],
      },
      // {
      //   title: 'learning',
      //   roles: ['admin', 'teacher', 'students', 'clients'],
      //   icon: <SidebarIcon variant={'learning'} />,
      //   items: [
      //     {
      //       title: 'groups',
      //       ...permissions.view_group_list,
      //     },
      //     {
      //       title: 'join_group',
      //       ...permissions.view_group_sign_up,
      //     },
      //     {
      //       title: 'clients_joined_groups',
      //       ...permissions.view_group_sign_up_clients,
      //     },
      //     {
      //       title: 'group_status_change',
      //       ...permissions.change_groups_statuses,
      //     },
      //   ],
      // },
      // {
      //   title: 'educational_testing',
      //   roles: ['admin', 'teacher', 'students', 'clients'],
      //   icon: <SidebarIcon variant={'tests'} />,
      //   items: [
      //     {
      //       title: 'tests',
      //       ...permissions.view_studytest_list,
      //     },
      //     {
      //       title: 'assigned_to_clients',
      //       ...permissions.view_studytest_purpose_test_list,
      //     },
      //     {
      //       title: 'view_studytest',
      //       ...permissions.view_studytest_purpose_student_test_list,
      //     },
      //     {
      //       title: 'requested_tests',
      //       ...permissions.view_request_test,
      //     },
      //   ],
      // },
      // {
      //   title: 'ebooks',
      //   roles: ['admin', 'teacher', 'students', 'clients'],
      //   icon: <SidebarIcon variant={'ebooks'} />,
      //   items: [
      //     {
      //       title: 'ebooks',
      //       ...permissions.view_ebook_books,
      //     },
      //     {
      //       title: 'ebooks',
      //       ...permissions.view_ebook_books_student,
      //     },
      //   ],
      // },
      {
        title: 'widget',
        roles: ['admin'],
        icon: <SidebarIcon variant={'widgets'} />,
        items: [
          {
            title: 'test_settings',
            ...permissions.view_widget_bundle_list,
          },
          {
            title: 'widgets_settings',
            ...permissions.view_placement_test_widget_list,
          },
        ],
      },
    ],
  },

  {
    id: 9,
    name: 'employees',
    isGroup: true,
    cats: [
      {
        title: 'employees',
        roles: ['admin'],
        icon: <SidebarIcon variant={'employees'} />,
        items: [
          {
            title: 'employees',
            ...permissions.view_employers_list,
          },
          {
            title: 'employee_schedule',
            ...permissions.view_worktable,
          },
          {
            title: 'birthdays',
            ...permissions.view_report_birthday,
          },
          {
            title: 'production_calendar',
            ...permissions.view_production_calendar_list,
          },
          // {
          //   title: 'templates_of_contracts',
          //   ...permissions.view_contract_template_list,
          // },
          // {
          //   title: 'employees_contracts',
          //   ...permissions.view_contract_signed,
          // },
          // {
          //   title: 'contracts_for_signature',
          //   ...permissions.view_contract_not_signed,
          // },
          // {
          //   title: 'contract_builder',
          //   ...permissions.view_contract_constructor,
          // },
        ],
      },
      {
        title: 'company',
        roles: ['admin'],
        icon: <SidebarIcon variant={'company'} />,
        items: [
          {
            title: 'companies',
            ...permissions.view_company_list,
          },
          {
            title: 'locations',
            ...permissions.view_locations_list,
          },
          {
            title: 'sent_letters',
            ...permissions.view_email_list,
          },
          // {
          //   title: 'sent_sms',
          //   ...permissions.view_sms_list,
          // },
        ],
      },
      // {
      //   title: 'study_group_settings',
      //   roles: ['admin'],
      //   icon: <SidebarIcon variant={'group_settings'} />,
      //   items: [
      //     {
      //       title: 'actions_for_ipm',
      //       ...permissions.view_coinactivity,
      //     },
      //     {
      //       title: 'level_condition',
      //       ...permissions.view_levelcondition,
      //     },
      //     {
      //       title: 'training_programs',
      //       ...permissions.view_programs_list,
      //     },
      //     {
      //       title: 'age_categories',
      //       ...permissions.view_age_list,
      //     },
      //     {
      //       title: 'disciplines_languages',
      //       ...permissions.view_disciplines_list,
      //     },
      //     {
      //       title: 'group_levels',
      //       ...permissions.view_levels_list,
      //     },
      //     {
      //       title: 'holidays',
      //       ...permissions.view_calendar_list,
      //     },
      //     {
      //       title: 'group_categories',
      //       ...permissions.view_levels_list,
      //     },
      //     {
      //       title: 'hourly_rates',
      //       ...permissions.view_settings_payment_list,
      //     },
      //     {
      //       title: 'discounts',
      //       ...permissions.view_discount_list,
      //     },
      //     {
      //       title: 'teacher_salaries',
      //       ...permissions.view_salary_list,
      //     },
      //     {
      //       title: 'certificates',
      //       ...permissions.view_certificates_list,
      //     },
      //     {
      //       title: 'evaluation_criteria',
      //       ...permissions.view_evaluation_list,
      //     },
      //     {
      //       title: 'ratings',
      //       ...permissions.view_rating_list,
      //     },
      //     {
      //       title: 'skill_level',
      //       ...permissions.view_skills_level,
      //     },
      //     {
      //       title: 'course_level',
      //       ...permissions.view_course_level,
      //     },
      //   ],
      // },
      {
        title: 'clients',
        roles: ['admin', 'teacher', 'students', 'clients'],
        icon: <SidebarIcon variant={'client'} />,
        items: [
          {
            title: 'all_clients',
            ...permissions.view_clients_list,
          },
          {
            title: 'training_application_templates',
            ...permissions.view_docs_template_list,
          },
          {
            title: 'all_requests',
            ...permissions.view_docs_all_requests,
          },
          {
            title: 'training_application_builder',
            ...permissions.view_docs_constructor,
          },
        ],
      },
    ],
  }, // Сотрудники

  {
    id: 6,
    name: 'reports',
    isGroup: true,
    cats: [
      //     {
      //       title: 'reports',
      //       icon: <SidebarIcon variant={'chart'} />,
      //       roles: ['admin', 'teacher', 'students', 'clients'],
      //       items: [
      //         {
      //           title: 'clients_with_debts',
      //           ...permissions.view_report_clients_debetors,
      //         },
      //         {
      //           title: 'clients_with_discounts',
      //           ...permissions.view_report_clients_discount,
      //         },
      //         {
      //           title: 'students_with_certificates',
      //           ...permissions.view_report_students_certificates,
      //         },
      //         {
      //           title: 'paid_hours',
      //           ...permissions.view_report_worked_hours,
      //         },
      //         {
      //           title: 'average_check',
      //           ...permissions.view_average_check_report,
      //         },
      //         {
      //           title: 'student_lifetime',
      //           ...permissions.view_client_lifetime_report,
      //         },
      //         {
      //           title: 'dropped_students',
      //           ...permissions.view_dropped_students_report,
      //         },
      //         {
      //           title: 'new_students',
      //           ...permissions.view_new_students_report,
      //         },
      //         {
      //           title: 'teacher_rating',
      //           ...permissions.view_teacher_rating_report,
      //         },
      //         {
      //           title: 'employee_rating',
      //           ...permissions.view_employee_rating_report,
      //         },
      //         {
      //           title: 'students_with_trial_lesson',
      //           ...permissions.view_trial_lesson_report,
      //         },
      //         {
      //           title: 'student_attendance_map',
      //           ...permissions.view_attendance_map_report,
      //         },
      //         {
      //           title: 'teacher_workload',
      //           ...permissions.view_teacher_loading_report,
      //         },
      //         {
      //           title: 'classroom_workload',
      //           ...permissions.view_audiences_loading_report,
      //         },
      //         {
      //           title: 'profitability',
      //           ...permissions.view_profitability_programs,
      //         },
      //         {
      //           title: 'teacher_statistics',
      //           ...permissions.view_ledger_teacher_statistics,
      //         },
      //         {
      //           title: 'client_stages',
      //           ...permissions.view_report_clients_stages,
      //         },
      //         {
      //           title: 'conversion_report',
      //           ...permissions.view_conversion_report,
      //         },
      //         {
      //           title: 'client_movement_report',
      //           ...permissions.view_dynamics_students_report,
      //         },
      //         {
      //           title: 'client_occupancy',
      //           ...permissions.view_client_occupancy_report,
      //         },
      //         {
      //           title: 'group_stages',
      //           ...permissions.view_group_stages_report,
      //         },
      //         {
      //           title: 'conversion',
      //           ...permissions.view_students_group_conversion_report,
      //         },
      //         {
      //           title: 'formed_groups',
      //           ...permissions.view_formed_groups_report,
      //         },
      //         {
      //           title: 'groups_launch_start',
      //           ...permissions.view_group_launch_speed_report,
      //         },
      //       ],
      //     },
      {
        title: 'invoice',
        roles: ['admin', 'students', 'clients'],
        icon: <SidebarIcon variant={'invoices'} />,
        items: [
          {
            title: 'all_invoices',
            ...permissions.view_client_orders_history,
          },
          // {
          //   title: 'entries_1c',
          //   ...permissions.view_1C_history,
          // },
          {
            title: 'refunds',
            ...permissions.view_refunds,
          },
          {
            title: 'funds_transfers',
            ...permissions.view_transfer,
          },
          // {
          //   title: 'receipt_of_funds',
          //   ...permissions.view_report_receipt_of_funds,
          // },
        ],
      },
    ],
  }, // Отчеты

  {
    id: 14,
    name: 'crm',
    roles: ['admin'],
    isGroup: true,
    cats: [
      {
        title: 'crm',
        roles: ['admin'],
        icon: <SidebarIcon variant={'crm'} />,
        items: [
          // {
          //   title: 'tasks',
          //   ...permissions.view_tasks_crm,
          //   link: 'crm/tasks',
          // },
          {
            title: 'clients_profiles',
            ...permissions.view_clients_crm,
            link: 'crm/clients-profiles',
          },
          {
            title: 'deferred_deals',
            ...permissions.view_deferred_deals_crm,
            link: 'crm/deferred-deals',
          },
          // {
          //   title: 'leads',
          //   ...permissions.view_leads_crm,
          //   link: 'crm/leads',
          // },
        ],
      },
      {
        title: 'tasks',
        roles: ['admin'],
        icon: <SidebarIcon variant={'crm'} />,
        items: [
          {
            title: 'tasks',
            ...permissions.view_tasks_crm,
            link: 'crm/tasks',
          },
        ],
      },
      {
        title: 'settings_crm',
        roles: ['admin'],
        icon: <SidebarIcon variant={'crm'} />,
        items: [
          {
            title: 'basic_settings',
            ...permissions.view_settings_crm,
            link: 'crm/settings',
          },
          {
            title: 'settings_user',
            ...permissions.view_settings_user_crm,
            link: 'crm/settings-user',
          },
          {
            title: 'settings_chat',
            ...permissions.view_settings_chat_crm,
            link: 'crm/settings-chat',
          },
          {
            title: 'settings_responsible',
            ...permissions.view_settings_chat_crm,
            link: 'crm/responsible',
          },
        ],
      },
      {
        title: 'analytics_crm',
        roles: ['admin'],
        icon: <SidebarIcon variant={'crm'} />,
        items: [
          {
            title: 'employee_analytics',
            ...permissions.view_employee_analytics_crm,
            link: 'crm/employee-analytics',
          },
          {
            title: 'call_analytics',
            ...permissions.view_calls_analytics_crm,
            link: 'crm/call-analytics',
          },
          {
            title: 'sales_analysis',
            ...permissions.view_sales_analytics_crm,
            link: 'crm/sales-analysis',
          },
          {
            title: 'summary_report',
            ...permissions.access_to_crm,
            link: 'crm/summary-report',
          },
          // {
          //   title: 'goals_analysis',
          //   ...permissions.view_goals_crm,
          //   link: 'crm/goals',
          // },
          // {
          //   title: 'list_of_events',
          //   ...permissions.view_event_history_crm,
          //   link: 'crm/list-of-events',
          // },
        ],
      },
      {
        title: 'wazzup',
        roles: ['admin'],
        icon: <SidebarIcon variant={'crm'} />,
        items: [
          {
            title: 'wazzup',
            ...permissions.access_to_crm,
            link: 'crm/wazzup',
          },
        ],
      },
    ],
  }, // CRM

  {
    id: 12,
    name: 'unidance',
    title: 'Unidance',
    roles: ['admin'],
    isGroup: true,
    cats: [
      {
        title: 'fitness_center',
        roles: ['admin'],
        icon: <SidebarIcon variant={'fitness'} />,
        items: [
          {
            title: 'clients',
            ...permissions.view_client_barcode,
          },
          {
            title: 'instructors',
            ...permissions.view_master,
          },
          {
            title: 'schedules',
            ...permissions.page_dance_schedules,
          },
          {
            title: 'training_lessons',
            ...permissions.page_training_lessons,
          },
          {
            title: 'subscriptions_settings',
            ...permissions.page_dance_subscriptions,
          },
        ],
      },
      {
        title: 'fitness_center_reports',
        roles: ['admin'],
        icon: <SidebarIcon variant={'chart'} />,
        items: [
          {
            title: 'statistics_by_coaches',
            ...permissions.view_stats_coaches_report,
          },
          {
            title: 'sold_subscriptions',
            ...permissions.view_subscriptions_sold_report,
          },
          {
            title: 'financial_report',
            ...permissions.view_finreport_report,
          },
          {
            title: 'zero_balance_subscription',
            ...permissions.view_mailing_report,
          },
        ],
      },
    ],
  }, // Фитнес центр + Отчеты фитнес-центра
]
